import Vue from 'vue'
import elementResizeDetectorMaker from 'element-resize-detector'

function bind (el, callback) {
  let lastHeight = el.clientHeight
  let lastWidth = el.clientWidth
  let first = true
  el.$$resizeDetector = {
    callback: callback,
    detector: elementResizeDetectorMaker({
      strategy: 'scroll'
    })
  }
  el.$$resizeDetector.detector.listenTo(el, () => {
    if (callback && (lastHeight !== el.clientHeight || lastWidth !== el.clientWidth || first)) {
      first = false
      callback(el)
    }
  })
}

function unbind (el) {
  el.$$resizeDetector.detector.uninstall(el)
}

Vue.directive('resize', {
  bind (el, binding) {
    bind(el, binding.value)
  },
  componentUpdated (el, binding) {
    unbind(el)
    bind(el, binding.value)
  },
  unbind: function (el) {
    unbind(el)
  }
})